let onResize: (() => void) | null = null;

export function initStickyMetrics(): void {
  const header = document.querySelector<HTMLElement>(".app-mode-header");
  const metrics = document.querySelector<HTMLElement>(".arf-metrics");

  // Re-runs on Turbo navigations, so always detach the previous listener first.
  if (onResize) {
    window.removeEventListener("resize", onResize);
    onResize = null;
  }

  // Only relevant on pages that render both the sticky topbar and the metrics bar.
  if (!header || !metrics) {
    document.documentElement.style.removeProperty("--arf-topbar-h");
    return;
  }

  const applyOffset = (): void => {
    const height = Math.round(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty("--arf-topbar-h", `${height}px`);
  };

  applyOffset();

  // The topbar reflows (its actions wrap) as the viewport width changes.
  onResize = applyOffset;
  window.addEventListener("resize", onResize);
}
